'use strict';

var jsxRuntime = require('react/jsx-runtime');

const PaperOverlap = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-paper_overlap--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M26 8C22.6863 8 20 10.6863 20 14V39C20 42.3137 22.6863 45 26 45H43.9999C47.3136 45 49.9999 42.3137 49.9999 39L50 15.9286L42.0588 8H26Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M42 15C42 15.5523 42.4477 16 43 16H50L42 8V15Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M16 17C12.6863 17 10 19.6863 10 23V48C10 51.3137 12.6863 54 16 54H33.9999C37.3136 54 39.9999 51.3137 39.9999 48L40 24.9286L32.0588 17H16Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M32 24C32 24.5523 32.4477 25 33 25H40L32 17V24Z",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M19 31H31",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M19 36H31",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("path", {
                    d: "M19 41H25",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "square",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-paper_overlap",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M26 8C22.6863 8 20 10.6863 20 14V39C20 42.3137 22.6863 45 26 45H43.9999C47.3136 45 49.9999 42.3137 49.9999 39L50 15.9286L42.0588 8H26Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M42 15C42 15.5523 42.4477 16 43 16H50L42 8V15Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M16 17C12.6863 17 10 19.6863 10 23V48C10 51.3137 12.6863 54 16 54H33.9999C37.3136 54 39.9999 51.3137 39.9999 48L40 24.9286L32.0588 17H16Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M32 24C32 24.5523 32.4477 25 33 25H40L32 17V24Z",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M19 31H31",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M19 36H31",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M19 41H25",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "square",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = PaperOverlap;
